import { NotificationType } from 'Common/NotificationManager';
import Mediator from 'Common/Mediator';
import * as $ from 'jquery';

interface IServerErrorDto {
    Error: string
}

interface IServerSuccessDto {
    Success: string
}

$(function () {
    $('button[type=submit]').click(function () {
        $('form.ajax-form[method=post]').attr('data-action-name', $(this).attr('name'));
    });
    
    // Hide successful messages after 10 secs
    if ($('.alert-success.alert-dismissible').length > 0) {
        $('.alert-success.alert-dismissible').delay(10000).fadeOut();
    }

    const mediator = Mediator.instance;

    var showSuccess = (response: IServerSuccessDto) => {
        mediator.publish('notification:show', response.Success, NotificationType.Success);
    };

    var resetButton = ($button, $html) => {
        $button.removeAttr('disabled');
        $button.html($html);
    };

    var redirect = data => {
        if (typeof (data) !== 'object') {
            data = JSON.parse(data);
        }

        if (data.redirect) {
            window.location.href = data.redirect;
        } else if (data.Success) {
            showSuccess(data);
        } else {
            window.scrollTo(0, 0);
            window.location.reload();
        }
    };

    var ScrollToValidationErrorIfAny = () => {
        const error = $(document).find('.validation-summary-errors:first');

        if (error.length) {
            $('html, body').animate({
                scrollTop: ($(error[0]).offset().top)
            }, 500);
        }
    };
    var highlightErrors = (response: JQueryXHR) => {
        const { Error: error = null } = response.responseJSON;

        const $form = $('form.ajax-form[method=post]');

        if (!$form) {
            return;
        }

        const $validationSummary = $form.find('.validation-summary-valid');

        if (error != null) {
            $validationSummary
                .toggleClass('validation-summary-valid validation-summary-errors')
                .find('ul')
                .append(`<li>${error}</li>`);
        } else {
            $.each(Object.keys(response.responseJSON),
                (ix, el) => {
                    var errors = response.responseJSON[el].Errors;
                    if (errors.length) {
                        const fieldId = el.replace('.', '_');

                        $(`.field-validation-valid[data-valmsg-for='${fieldId}']`)
                            .toggleClass('field-validation-valid field-validation-error')
                            .text(errors[0].ErrorMessage);

                        $validationSummary
                            .find('ul')
                            .append(`<li>${errors[0].ErrorMessage}</li>`);
                    }
                });

            if ($validationSummary.find('li').length) {
                $validationSummary
                    .toggleClass('validation-summary-valid validation-summary-errors');
            }
        }
        ScrollToValidationErrorIfAny();
    };

    const $ajaxForm = $('form.ajax-form[method=post]');
    const buttons = $ajaxForm.find('button[type = submit]');
    var submitter = null;

    buttons.on('click', function () {
        submitter = this;
    });

    $ajaxForm.on('submit', function () {
        if (submitter === null) {
            return false;
        }

        submitter = null;

        const thisForm = $(this);
        // hide other alerts
        $('.alert-dismissible').hide();
        if (!thisForm.valid()) {
            return this;
        }

        const actionName = thisForm.attr('data-action-name');

        var $submitButton = actionName
            ? thisForm.find(`button[type = submit][name ='${actionName}']`)
            : thisForm.find('button[type = submit]');

        var $submitButtonValue = $submitButton.html();

        $submitButton.html('<div class="ajax-loader"></div>');
        $submitButton.attr('disabled', 'true');

        $(window).unbind();

        // clean-up forms validation block
        $(document).find('.validation-summary-errors:first')
            .toggleClass('validation-summary-errors validation-summary-valid')
            .find('ul li')
            .remove();

        const formData = new FormData(this as HTMLFormElement);
        formData.append(actionName, '');

        $.ajax({
            url: thisForm.attr('action'),
            type: 'post',
            headers: { 'X-Ajax-Form': 'true' },
            data: formData,
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            statusCode: {
                200: redirect,
                400: highlightErrors,
                530: highlightErrors,
                500: highlightErrors
            },
            success: (data) => {
                if (typeof (data) !== 'object') {
                    data = JSON.parse(data);
                }

                if (data.redirect) {
                    return;
                }

                resetButton($submitButton, $submitButtonValue);
            },
            error: data => {
                resetButton($submitButton, $submitButtonValue);
            }
        });

        return false;
    });
});
